import type { SVGProps } from "react";
export function CheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-slot="icon"
      fill="none"
      height={800}
      viewBox="0 0 24 24"
      width={800}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m19 7-8.75 10-5.25-4.5455"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  );
}
